<template>
	<p class="news-info">
		<span class="source">{{ data.source }}</span>
		<span class="time">{{ data.time | timeAgo }}</span>
	</p>
</template>
<script>
	export default {
		name: "newsInfo",
		props: {
			data: {
				required: true,
				type: Object
			}
		},
		filters: {
			timeAgo(val) {
				let diff = (new Date().getTime() - val) / 1000;
				let suffix = "前";
				let getTimeAgo = seconds => {
					let minutes = seconds / 60;
					let hours = seconds / 3600;
					let days = seconds / (3600 * 24);
					let months = seconds / (3600 * 24 * 30);
					let years = seconds / (3600 * 24 * 365);
					if (years >= 1) {
						return Math.round(years) + "年";
					} else if (months >= 1) {
						return Math.round(months) + "个月";
					} else if (days >= 1) {
						return Math.round(days) + "天";
					} else if (hours >= 1) {
						return Math.round(hours) + "小时";
					} else if (minutes >= 1) {
						return Math.round(minutes) + "分钟";
					} else {
						suffix = "";
						return "刚刚";
					}
				};
				return getTimeAgo(diff) + suffix;
			}
		}
	};
</script>